import React, { useState, useEffect, useCallback, useRef } from 'react';
import ReactDOM from 'react-dom';
import GeneralForm from '../../../components/Forms/GCForm';
import BottomNavigation from '../../../components/BottomNavigation';
import addressValidationSchema from './addressValidationSchema';
import FormFields from './FormFields';
import { X } from 'lucide-react';
import { Toast } from 'react-bootstrap';
import { conf } from '../../../../../confg';
import axios from 'axios';
import useMobileSize from '../../../../goldTrading/hooks/useMobileSize';

const ADDRESS_FORM_ID = 'address-form-modal';

const AddressForm = ({
  vahed,
  state_id,
  pelak,
  label,
  entry_street_address,
  city_id,
  entry_firstname,
  entry_lastname,
  entry_postcode,
  title,
  buttonText,
  buttonLoadingText,
  setIsAddMenuOpen,
  address_book_id,
  type = 'add' || 'edit',
  handleReload = () => {},
  hasTitle = true,
  hasMarginButton = true,
  hasButtonNavigation = true,
  footerContainerRef,
}) => {
  const isMobile = useMobileSize();
  const [showToast, setShowToast] = useState(false);
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [errorToastMessage, setErrorToastMessage] = useState('');
  const class_toast = 'bg-success';

  const [isSubmitting, setIsSubmitting] = useState(false);
  const defaultValue = {
    city_id: '',
    entry_firstname: entry_firstname ?? '',
    entry_lastname: entry_lastname ?? '',
    entry_postcode: entry_postcode ?? '',
    entry_street_address: entry_street_address ?? '',
    label: label ?? '',
    pelak: pelak ?? '',
    state_id: '',
    vahed: vahed ?? '',
  };

  const handleToastClose = () => {
    setShowToast(false);
  };

  const errorToastTimerRef = useRef(null);

  const handleValidationError = useCallback((errors) => {
    if (!errors || typeof errors !== 'object') return;
    const messages = Object.values(errors).filter(Boolean);
    if (messages.length > 0) {
      setErrorToastMessage(messages.join('\n'));
      setShowErrorToast(true);
      if (errorToastTimerRef.current) clearTimeout(errorToastTimerRef.current);
      errorToastTimerRef.current = setTimeout(() => setShowErrorToast(false), 6000);
    }
  }, []);

  useEffect(() => () => {
    if (errorToastTimerRef.current) clearTimeout(errorToastTimerRef.current);
  }, []);

  useEffect(() => {
    const container = footerContainerRef?.current;
    if (container) {
      const submitButton = (
        <button
          type='submit'
          form={ADDRESS_FORM_ID}
          className='confirm-button modal-address-footer-btn'
          disabled={isSubmitting}
          style={isSubmitting ? { opacity: 0.7, cursor: 'not-allowed' } : {}}
        >
          {isSubmitting ? <span className='loading-spinner'></span> : <span className='confirm-text'>{buttonText ?? 'ثبت'}</span>}
        </button>
      );
      ReactDOM.render(submitButton, container);
      return () => {
        try {
          ReactDOM.unmountComponentAtNode(container);
        } catch (_) {}
      };
    }
  }, [footerContainerRef, isSubmitting, buttonText]);

  const handleSubmit = (data) => {
    const [city_id, entry_city] = data.city_id.split('-').map((item) => item.trim());
    const [state_id, entry_state] = data.state_id.split('-').map((item) => item.trim());
    delete data.city_id;
    delete data.state_id;

    const newFormData = {
      ...data,
      city_id,
      entry_city,
      state_id,
      entry_state,
      longitude: '35',
      latitude: '25',
    };
    setIsSubmitting(true);
    if (type === 'add') {
      axios({
        url: conf.server_url + 'addresses',
        method: 'POST',
        data: newFormData,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
      })
        .then((e) => {
          if (e.status === 200) {
            setIsSubmitting(false);
            setShowToast(true);
            // ✅ بعد از 2 ثانیه Toast و Modal رو ببند
            setTimeout(() => {
              setShowToast(false);
              setIsAddMenuOpen();
              handleReload(e?.data[e?.data.length - 1]['address_book_id']);
            }, 2000);
          }
        })
        .catch(() => {
          setIsSubmitting(false);
          setErrorToastMessage('خطا در ثبت آدرس. لطفاً دوباره تلاش کنید.');
          setShowErrorToast(true);
        });
    }

    if (type === 'edit') {
      axios({
        url: conf.server_url + 'addresses/' + address_book_id,
        method: 'PUT',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
        data: newFormData,
      })
        .then((e) => {
          if (e.status === 200) {
            setIsSubmitting(false);
            setShowToast(true);
            // ✅ بعد از 2 ثانیه Toast و Modal رو ببند
            setTimeout(() => {
              setShowToast(false);
              handleReload();
              setIsAddMenuOpen();
            }, 2000);
          }
        })
        .catch(() => {
          setIsSubmitting(false);
          setErrorToastMessage('خطا در ویرایش آدرس. لطفاً دوباره تلاش کنید.');
          setShowErrorToast(true);
        });
    }
  };

  return (
    <div className='modal-overlay-address'>
      <div className='modal-content-address'>
        <div
          style={{
            marginBlock: hasMarginButton ? '16px' : '0px',
            width: '100%',
            backgroundColor: 'white',
            marginTop: '16px',
            marginBottom: isMobile && hasMarginButton ? '120px' : '0px',
          }}
        >
          {hasTitle && (
            <div className='form-title-content-address' style={{ display: 'flex', flexDirection: 'row-reverse', alignItems: 'center', paddingInline: '10px' }}>
              <p className={'form-title-address'}>{title}</p>
              <X onClick={() => setIsAddMenuOpen()} style={{ cursor: 'pointer' }} />
            </div>
          )}
          <div style={{ marginBottom: hasMarginButton ? '30px' : '0px' }}>
            <GeneralForm
              formId={footerContainerRef ? ADDRESS_FORM_ID : undefined}
              validationSchema={addressValidationSchema}
              FormFieldsComponent={FormFields}
              initialValues={defaultValue}
              submitHandler={handleSubmit}
              onValidationError={handleValidationError}
              title={title ?? 'اطلاعات آدرس'}
              hasTitle={false}
              buttonText={buttonText ?? 'ثبت'}
              buttonLoadingText={buttonLoadingText ?? 'در حال ثبت '}
              buttonLoading='test'
              enableReinitialize={true}
              isSubmitting={isSubmitting}
              hasNoBorder={true}
            />
          </div>
          {isMobile && hasButtonNavigation && <BottomNavigation />}
        </div>
      </div>

      {/* ✅ Toast با setTimeout */}
      <Toast
        style={isMobile ? { position: 'fixed', top: '20px', right: '20px', zIndex: 999999999999 } : { position: 'fixed', bottom: '20px', right: '20px', zIndex: 999999999999 }}
        className={'rtl position-fixed color-white z-index-top ' + class_toast}
        show={showToast}
        onClose={handleToastClose}
        autohide={false}
      >
        <Toast.Body>{type === 'add' ? 'آدرس شما با موفقیت ثبت شد' : 'آدرس شما با موفقیت ویرایش شد'}</Toast.Body>
      </Toast>

      <Toast
        style={isMobile ? { position: 'fixed', top: '20px', right: '20px', zIndex: 999999999999, maxWidth: '90vw' } : { position: 'fixed', bottom: '20px', right: '20px', zIndex: 999999999999, maxWidth: '400px' }}
        className='rtl position-fixed color-white z-index-top bg-danger'
        show={showErrorToast}
        onClose={() => setShowErrorToast(false)}
        autohide
        delay={6000}
      >
        <Toast.Body style={{ whiteSpace: 'pre-line', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '12px' }}>
          <span style={{ flex: 1 }}>{errorToastMessage}</span>
          <button
            type='button'
            aria-label='بستن'
            onClick={() => setShowErrorToast(false)}
            style={{ background: 'none', border: 'none', color: 'white', fontSize: '1.2rem', cursor: 'pointer', padding: '0 4px' }}
          >
            ×
          </button>
        </Toast.Body>
      </Toast>
    </div>
  );
};

export default AddressForm;
